import { AnnouncementCategory, AnnouncementAudience } from '../../enum/mysec/announcement-category.enum';

export class AnnouncementModel {
  body: string;
  category: AnnouncementCategory;
  audience: AnnouncementAudience;  //PLT-1783
  companyId: number;
  description: string;
  id: number;
  publishedAt: string;
  referenceNo: string;
  title: string;
  isPublished?: boolean;
}
